module.exports = __webpack_public_path__ + "static/media/carousel-2.e4b2a409.png";